import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles, Item, ItemDetails } from './index';
import { formatShortDate } from '../../utils/date';
import {
  checkIfApplicable,
  checkValidationBasedOnDate,
  currencyConversion,
  displayPlacementCost,
  isLVFSchemeCodeOperatingExpense,
} from '../../utils/utilityFunctions';
import {
  accredidateValidationDate,
  EXCLUDE_CLAUSE_MASTER,
  excludeClauseSubLabel,
  hurdleRateMaster,
  YesNoBooleanMaster,
} from '../../utils/constant';
import { DataTable } from '../DataTable';
import { addHurdleRate } from '../../redux-store/types/funds';
import ExitCharge from './exitCharge';

export default function InvestAndPaymentDetails({
  application,
}: {
  application: Partial<ApplicationProps>;
}): JSX.Element {
  const columns: any = [
    {
      header: !['4', '5'].includes(application?.schemeId?.toString() || '')
        ? 'Hurdle Rate (p.a.)'
        : 'Hurdle Rate of Return',
      label: 'hurdleRate',
      valueGetter: (row: any) => row.hurdleRate || 'N/A',
    },
    {
      header: !['4', '5'].includes(application?.schemeId?.toString() || '')
        ? 'Performance Fees'
        : 'Additional Return',
      label: 'performanceFee',
      valueGetter: (row: any) =>
        row.performanceFee || row.performanceFee === 0 ? `${row.performanceFee} %` : 'N/A',
    },
  ];
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Investment Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                {checkValidationBasedOnDate(
                  application?.createdAt || '',
                  accredidateValidationDate
                ) && (
                  <KeyValue
                    title={'Accredited Investor'}
                    description={
                      YesNoBooleanMaster[application.isAccreditedInvestor?.toString() || '']
                    }
                  />
                )}
                <KeyValue title={'Fund (Scheme)'} description={application.scheme?.schemeName} />
                {checkIfApplicable(application.scheme?.excludeClauseApplicableInPlan || '') && (
                  <Grid item xs={12} sm={6}>
                    <Item>{`Excuse and Exclude Clause Undersigning`}</Item>
                    <Item sx={{ pt: 0 }}>{`(${excludeClauseSubLabel})`}</Item>
                    <ItemDetails sx={{ pt: 1 }}>
                      {EXCLUDE_CLAUSE_MASTER[application.excludeClause || ''] || '-'}
                    </ItemDetails>
                  </Grid>
                )}
                <KeyValue title={'Class Plan'} description={application.plan?.planDescription} />
                <KeyValue
                  title={'Commitment Amount'}
                  description={application.commitmentAmount?.toString()}
                  amount={currencyConversion(application.commitmentAmount)}
                />
                <KeyValue
                  title={'Operating Expenses'}
                  description={
                    (application.operatingExpenses === 0 || application.operatingExpenses) &&
                    (isLVFSchemeCodeOperatingExpense(
                      application?.schemeId ? Number(application.schemeId) : null
                    )
                      ? `At actuals, subject to a cap of ${application.operatingExpenses?.toString()}% per annum of the AUM`
                      : `On actuals subject to cap of ${application.operatingExpenses?.toString()}% of daily average NAV`)
                  }
                />

                <KeyValue
                  title={`Management Fees Rate ${
                    application?.managementFeeCheck ? '(Before Onboarding)' : ''
                  }`}
                  description={
                    (application.managementFeesRate === 0 || application.managementFeesRate) &&
                    `${application.managementFeesRate?.toString()}% p.a.`
                  }
                />
                {application?.managementFeeCheck && (
                  <KeyValue
                    title={'Management Fees Rate (After Onboarding)'}
                    description={
                      (application.managementFeeAfterCommitment === 0 ||
                        application.managementFeeAfterCommitment) &&
                      `${application.managementFeeAfterCommitment?.toString()}% p.a.`
                    }
                  />
                )}
                {/* <KeyValue
                  title={'Hurdle rate'}
                  description={
                    hurdleRateMaster?.find((item) => item.hurdleRate === application.hurdleRate)
                      ?.displayText
                  }
                />
                <KeyValue title={'Performance fee'} description={application.performanceFee} /> */}
                {displayPlacementCost(
                  application.plan?.planCode as string,
                  application.scheme?.schemeCode as string
                ) && (
                  <KeyValue
                    title={'Placement Cost'}
                    description={
                      (application.placementCost === 0 || application.placementCost) &&
                      `Placement Cost @ ${application.placementCost?.toString()}% of Capital Commitment`
                    }
                  />
                )}
                {/* <KeyValue title={'Tax Rate'} description={application.taxRate} /> */}
                {/* <KeyValue title={'DrawDown Number'} description={application.drawDownNumber} /> */}
                <KeyValue
                  title={'Contribution Amount'}
                  description={application.contributionChequeAmount?.toString()}
                  amount={currencyConversion(application.contributionChequeAmount)}
                />
                <KeyValue
                  title={
                    !['4', '5'].includes(application?.schemeId?.toString() || '')
                      ? 'Setup Fee Percentage'
                      : 'Organizational Expenses'
                  }
                  description={
                    (application.setupFeePercentage === 0 || application.setupFeePercentage) &&
                    `On actuals subject to cap of ${application.setupFeePercentage}% of the Capital Commitment`
                  }
                />
                {/* <KeyValue
                  title={'Setup Fee Amount'}
                  description={application.setupFeeAmount}
                  amount={currencyConversion(application.setupFeeAmount)}
                />
                <KeyValue
                  title={'GST (GST On Setup Fee Amount)'}
                  description={application.setupFeeGST}
                  amount={currencyConversion(application.setupFeeGST)}
                />
                <KeyValue
                  title={'Total Setup Fee'}
                  description={application.totalSetupFee}
                  amount={currencyConversion(application.totalSetupFee)}
                />
                <KeyValue
                  title={'TDS'}
                  description={application.setupFeeTDS}
                  amount={currencyConversion(application.setupFeeTDS)}
                />
                <KeyValue
                  title={'Setup Fee Payable'}
                  description={application.netSetupFeeLessTDS}
                  amount={currencyConversion(application.netSetupFeeLessTDS)}
                /> */}
                <KeyValue
                  title={'Total Amount Payable'}
                  description={application.totalAmountPayable?.toString()}
                  amount={currencyConversion(application.totalAmountPayable)}
                />

                {checkIfApplicable(application?.plan?.exitChargeApplicable || '') && (
                  <Grid item xs={12} pb={2}>
                    <ExitCharge exitCharge={application?.plan?.exitCharge} />
                  </Grid>
                )}
                <Grid item xs={12} sm={12} md={12}>
                  <DataTable
                    tableData={
                      application.plan?.hurdlerates?.length
                        ? application.plan.hurdlerates
                        : [{ hurdleRate: '-', performanceFee: '-' }]
                    }
                    tableHeader={columns}
                    noOfPages={1}
                    renderAdditionalRow={true}
                    tableBodyCustomStyles={{
                      '.MuiTableCell-root': {
                        borderBottom: 'none',
                      },
                    }}
                    tableHeaderCustomStyles={{
                      '.MuiTableCell-head': {
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'primary.main',
                        textAlign: 'left',
                        pl: 2,
                      },
                    }}
                    rowCustomStyles={{
                      '.MuiTableCell-root': {
                        py: 0,
                        overflowWrap: 'anywhere',
                        textAlign: 'left',
                        verticalAlign: 'top',
                      },
                    }}
                    boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
                  />
                </Grid>
              </Grid>
            </Gridstyles>
          </Grid>
        </Box>
        <Box sx={{ p: 2 }}>
          {/* <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Payment Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue title={'Payment Bank Name'} description={application.paymentBankame} />
                <KeyValue
                  title={'Payment Bank Account Number'}
                  description={application.paymentBankAccountNumber}
                />
                <KeyValue
                  title={'Payment Bank Account Type'}
                  description={application.paymentBankAccontType}
                />
                <KeyValue title={'Mode Of Payment'} description={application.modeOfPayment} />
                <KeyValue
                  title={'Payment/Cheque Date'}
                  description={formatShortDate(application.chequeDate)}
                />
                <KeyValue title={'Payment Ref No'} description={application.paymentRefNo} />
              </Grid>
            </Gridstyles>
          </Grid> */}
        </Box>
      </Box>
    </>
  );
}
